import React from 'react'
import SelectProduct from '@page-components/Order/Products/ProductsContent/SelectProduct'
import {useSelectedProductId} from '@page-components/OrderV2/useSelectedProduct'

export default function ProductModal({paginatedProducts, onClose}) {
  const productId = useSelectedProductId()

  if (!paginatedProducts || !productId) {
    return null
  }

  const product = paginatedProducts.items.find(p => p._id === productId)
  if (!product) {
    return null
  }

  return <SelectProduct allowEdit={false} product={product} open={true} close={onClose} />
}
